exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".register-info-box{background-color:#e3f2fd;border:1px solid #bbdefb;border-radius:6px;padding:12px;margin-top:8px;font-size:.875rem;color:#1565c0}.register-info-box .info-title{font-weight:600;margin-bottom:8px;display:flex;align-items:center}.register-info-box .info-title i{margin-right:6px;color:#1976d2}.register-info-box .info-details{line-height:1.4}.register-info-box .info-details strong{color:#0d47a1}.register-info-box .info-details div{margin-bottom:4px}.register-info-box .info-details div:last-child{margin-bottom:0}", ""]);

// exports
